module.exports = __webpack_public_path__ + "img/home_collections_en.cd02df1.png";